import { Injectable } from '@angular/core';
import { DatabaseService } from './db-service';
import { DocumentReference, SportTeam, SportLeague } from '../models';
import { environment } from '../../environments/environment';
import { AngularFirestore } from '@angular/fire/firestore';
import { Sport } from '../enums';


@Injectable({
  providedIn: 'root'
})

export class SportTeamService {
    
    public collection: string = 'sportTeams';

    constructor(
        private afstore: AngularFirestore,
        private dbservice: DatabaseService) {
    }

    /**
     * Get list of teams
     * @param churchRef reference of Church
     * @param ageGroupRef reference of AgeGroup
     */
    public getSportTeams(churchRef: DocumentReference, sport: Sport) {
        if (churchRef && churchRef.displayName === 'All Churches') {
            return this.dbservice.getDocuments(this.collection, ref => ref
                .where('serviceYear', '==', environment.serviceYear)
                .where('sport', '==', sport)
                .where('isActive', '==', true)
                .where('isDeleted', '==', false)
            );
        }
        return this.dbservice.getDocuments(this.collection, ref => ref
            .where('serviceYear', '==', environment.serviceYear)
            .where('church', '==', churchRef)
            .where('sport', '==', sport)
            .where('isActive', '==', true)
            .where('isDeleted', '==', false)
        );
    }

    public getAllSportTeams(sport: Sport) {
        return this.dbservice.getDocuments(this.collection, ref => ref
            .where('serviceYear', '==', environment.serviceYear)
            .where('sport', '==', sport)
            .where('isActive', '==', true)
            .where('isDeleted', '==', false)
        );
    }

    public getSportLeagueTeams(churchRef: DocumentReference, sport: Sport, sportLeague: SportLeague) {
        return this.dbservice.getDocuments(this.collection, ref => ref
            .where('serviceYear', '==', environment.serviceYear)
            .where('church', '==', churchRef)
            .where('sport', '==', sport)
            .where('league', '==', sportLeague)
            .where('isActive', '==', true)
            .where('isDeleted', '==', false)
        );
    }

    public getSportList() {
        const sportList: any = [];
        sportList.push({ name: Sport[Sport.Basketball], value: Sport.Basketball });
        sportList.push({ name: Sport[Sport.Chess], value: Sport.Chess });
        sportList.push({ name: Sport[Sport.ElectronicGames], value: Sport.ElectronicGames });
        sportList.push({ name: Sport[Sport.Netball], value: Sport.Netball });
        sportList.push({ name: Sport[Sport.Soccer], value: Sport.Soccer });
        sportList.push({ name: Sport[Sport.TableTennis], value: Sport.TableTennis });
        sportList.push({ name: Sport[Sport.Volleyball], value: Sport.Volleyball });
        
        return sportList;
    }

    // CRUD functions
    // Create
    public async createSportTeam(sportTeam: SportTeam) {
        sportTeam.serviceYear = environment.serviceYear;

        const id = this.afstore.createId();
        this.afstore.collection(this.collection).doc(id).set(sportTeam);
        return id;
    }

    public async getMemberTeams(teamMember: DocumentReference) {
        return this.dbservice.getDocuments(this.collection, ref => ref
            .where('serviceYear', '==', environment.serviceYear)
            .where('memberList', 'array-contains', teamMember)
            .where('isActive', '==', true)
            .where('isDeleted', '==', false)
        );
    }
}
